var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.4609C17.5523 10.4609 18 10.8846 18 11.4062V16.0557C17.9999 16.5772 17.5522 17 17 17H1C0.44777 17 6.74105e-05 16.5772 0 16.0557V11.4062C0 10.8846 0.447728 10.4609 1 10.4609C1.55226 10.4609 2 10.8847 2 11.4062V15.1113H16V11.4062C16 10.8847 16.4477 10.4609 17 10.4609ZM9.20508 0C9.75731 2.27984e-08 10.205 0.422783 10.2051 0.944336V9.99902L12.7041 7.63867C13.0946 7.27014 13.7277 7.27003 14.1182 7.63867C14.5087 8.00748 14.5086 8.60577 14.1182 8.97461L9.91211 12.9473C9.71656 13.1319 9.4604 13.2229 9.2041 13.2227C9.07629 13.2226 8.94836 13.2013 8.82812 13.1553C8.73793 13.1207 8.65171 13.0732 8.57324 13.0127C8.54704 12.9925 8.5215 12.9703 8.49707 12.9473C8.49355 12.9439 8.49076 12.9399 8.4873 12.9365L4.29199 8.97461C3.90148 8.60578 3.90148 8.0075 4.29199 7.63867C4.68249 7.27013 5.31562 7.27003 5.70605 7.63867L8.20508 9.99902V0.944336C8.20514 0.422896 8.65301 0.000183977 9.20508 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.3e2654a03cd937ac6cf829e010e489be.svg";
export { ForwardRef as ReactComponent };